import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _downvoteRequest = {};
var _downvoteResponse = { vote: '_vote' };
var _queryVotesRequest = {};
var _queryVotesResponse = { votes: '_vote' };
var _removeVoteRequest = {};
var _removeVoteResponse = { vote: '_vote' };
var _updateVoteRequest = {
    fieldMask: 'google.protobuf.FieldMask',
    vote: '_vote',
};
var _updateVoteResponse = { vote: '_vote' };
var _upvoteRequest = {};
var _upvoteResponse = { vote: '_vote' };
var _vote = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
function resolveComWixpressCommentsVotesUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/votes',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/votes',
                destPath: '/v1/votes',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/v1/votes',
                destPath: '/v1/votes',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/votes',
                destPath: '/v1/votes',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Cast a upvote on a given resource */
export function upvote(payload) {
    var _a = serializer(_upvoteRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_upvoteResponse, { _vote: _vote }).fromJSON;
    function __upvote(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.comments.v1.vote',
            method: 'POST',
            methodFqn: 'com.wixpress.comments.Votes.Upvote',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressCommentsVotesUrl({
                protoPath: '/v1/votes/upvote',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __upvote.fromReq = fromReq;
    __upvote.__isAmbassador = true;
    return __upvote;
}
/** Cast a downvote on a given resource */
export function downvote(payload) {
    var _a = serializer(_downvoteRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_downvoteResponse, { _vote: _vote }).fromJSON;
    function __downvote(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.comments.v1.vote',
            method: 'POST',
            methodFqn: 'com.wixpress.comments.Votes.Downvote',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressCommentsVotesUrl({
                protoPath: '/v1/votes/downvote',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __downvote.fromReq = fromReq;
    __downvote.__isAmbassador = true;
    return __downvote;
}
/** Updates a vote */
export function updateVote(payload) {
    var _a = serializer(_updateVoteRequest, {
        _vote: _vote,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateVoteResponse, { _vote: _vote }).fromJSON;
    function __updateVote(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.comments.v1.vote',
            method: 'PATCH',
            methodFqn: 'com.wixpress.comments.Votes.UpdateVote',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressCommentsVotesUrl({
                protoPath: '/v1/votes/{vote.voteId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateVote.fromReq = fromReq;
    __updateVote.__isAmbassador = true;
    return __updateVote;
}
/** Remove existing vote for given resource */
export function removeVote(payload) {
    var _a = serializer(_removeVoteRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_removeVoteResponse, { _vote: _vote }).fromJSON;
    function __removeVote(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.comments.v1.vote',
            method: 'DELETE',
            methodFqn: 'com.wixpress.comments.Votes.RemoveVote',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressCommentsVotesUrl({
                protoPath: '/v1/votes/{voteId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __removeVote.fromReq = fromReq;
    __removeVote.__isAmbassador = true;
    return __removeVote;
}
/** Query votes */
export function queryVotes(payload) {
    var _a = serializer(_queryVotesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryVotesResponse, { _vote: _vote }).fromJSON;
    function __queryVotes(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.comments.v1.vote',
            method: 'POST',
            methodFqn: 'com.wixpress.comments.Votes.QueryVotes',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressCommentsVotesUrl({
                protoPath: '/v1/votes',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryVotes.fromReq = fromReq;
    __queryVotes.__isAmbassador = true;
    return __queryVotes;
}
//# sourceMappingURL=http.impl.js.map